import { getDaysInMonth } from "date-fns"

export const getAllDaysInMonth = (dayIndex: number, date: Date): number[] => {
  const result: number[] = []
  const year = date.getFullYear()
  const month = date.getMonth()
  const lastDayOfMonth = getDaysInMonth(date)

  for (let day = 1; day <= lastDayOfMonth; day++) {
    const newDate = new Date(year, month, day)
    if (newDate.getDay() === dayIndex) {
      result.push(day)
    }
  }

  return result
}

export const getNumberEnding = function (d: number) {
  if (d > 3 && d < 21) return "th"

  switch (d % 10) {
    case 1:
      return "st"
    case 2:
      return "nd"
    case 3:
      return "rd"
    default:
      return "th"
  }
}
